import type { ImsCostingMethod } from "@redotech/crdb-enums/inventory/ims-costing-method";
import { LoadState, useLoad } from "@redotech/react-util/load";
import { useContext } from "react";
import { RedoInventoryRpcClientContext } from "../inventory-rpc-client-provider";

export type CostLedgerMethod =
  | ImsCostingMethod.WeightedAverage
  | ImsCostingMethod.Fifo;

/**
 * The account's ledger method, null without a ledger, undefined until loaded.
 * Pass `enabled: false` for users without inventory access to skip the call.
 */
export function useCostLedgerStatus({
  enabled = true,
}: { enabled?: boolean } = {}): LoadState<CostLedgerMethod | null> {
  const client = useContext(RedoInventoryRpcClientContext);
  return useLoad(
    async (signal) => {
      if (!enabled || !client) {
        return null;
      }
      return (await client.getCostLedgerStatus({}, { signal })).method;
    },
    [client, enabled],
  );
}
